import { MOVED_LOGIN_URL, PLATFORM_MOVED_CODE } from '@/lib/auth/platform';

/**
 * The browser half of PLATFORM_MOVED: the server half (`api-fetch.ts`) has
 * already cleared the cookies when this 409 arrives through a route handler.
 * A full navigation, not router.push, so the edge re-evaluates `cp_platform`.
 */
export function redirectIfPlatformMoved(status: number, code: string | undefined): boolean {
  if (status !== 409 || code !== PLATFORM_MOVED_CODE) return false;
  window.location.assign(MOVED_LOGIN_URL);
  return true;
}
